<template>
  <b-button
      :disabled="pending"
      type="submit"
      variant="primary"
      @click="$emit('click', $event)"
  >
    {{ $t('Save') }}

    <b-spinner v-if="pending" small />
    <fa v-else class="ml-1" icon="save" />
  </b-button>
</template>
<script>
export default {
  name: 'SubmitButton',
  props: {
    pending: {
      type: Boolean,
      default: false
    }
  }
}
</script>
